import * as z from 'zod'
import { McIssueListItem } from '../McIssueEntity.js'
import { GetApiContract, PatchApiContract } from './ApiContract.js'
import { schemaBoolish } from './zodUtils.js'

export interface GetMcIssuesListRequest extends GetApiContract {
    Response: Array<McIssueListItem>
    ResponseJson: Array<McIssueListItem>
}

export const patchMcIssuesSchema = z.object({
    archived: schemaBoolish,
    isConvertible: schemaBoolish.nullish(),
})

export interface PatchMcIssuesRequest<
    T = {
        id: string
        instrumentHistoryId: string
        archivedAt: string
        isConvertible: 0 | 1
    },
> extends PatchApiContract {
    Body: z.input<typeof patchMcIssuesSchema>
    Response: T
    ResponseJson: T
}
